import React, { Component } from 'react'
import noop from 'lodash/noop'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import Scroller from 'client/shared/blocks/scroller'
import { Sticker } from 'client/shared/blocks/sticker'

import { MinimalAuthorInfo } from 'client/shared/types/author'
import { NavItem } from 'client/bookmate/helpers/nav-helper'
import { SubHeaderDefault } from './sub-header-default/sub-header-default'

import './sub-header.styl'
import { QueryParams } from 'shared/tools/url-helper'

export type SubHeaderProps = {
  title: string
  kind: 'default' | 'full' | 'user'
  authors?: MinimalAuthorInfo[] | string
  previewLink: string
  renderCover?: () => Node
  renderButton: () => Node
  renderFloatingAction: () => Node | null | undefined
  nav: NavItem[]
  fixed: boolean
  hidden?: boolean | null | undefined
  query?: QueryParams
} & DecoratorProps

type State = {
  fixed: boolean
}

class _SubHeader extends Component<SubHeaderProps, State> {
  static defaultProps = {
    fixed: false,
    renderFloatingAction: noop,
  }

  state = {
    fixed: false,
  }

  fix = () => {
    this.setState({ fixed: true })
  }

  unfix = () => {
    this.setState({ fixed: false })
  }

  isFixed(): boolean {
    const { fixed } = this.props

    return fixed || this.state.fixed
  }

  render(): JSX.Element {
    const { fixed } = this.props

    return fixed ? this.renderStickySubHeader() : this.renderFixedSubHeader()
  }

  renderStickySubHeader(): JSX.Element {
    const defaultProps = {
      ...this.props,
      isFixed: false,
      isVisible: true,
    }
    return (
      <Sticker>
        <SubHeaderDefault {...defaultProps} />
      </Sticker>
    )
  }

  renderFixedSubHeader(): JSX.Element {
    const defaultProps = {
      ...this.props,
      isFixed: this.isFixed(),
      isVisible: this.isFixed(),
    }

    return (
      <Scroller onReach={{ top: this.fix, bottom: this.unfix }}>
        <SubHeaderDefault {...defaultProps} />
      </Scroller>
    )
  }
}

export const SubHeader = uiBox(_SubHeader)
